// The free-book download link shown on the Thank-You page (a BookFunnel link).
// Leave empty until it's ready and that part of the page simply doesn't appear.
export const FREE_BOOK_URL = '';
export const FREE_BOOK_TITLE = 'Manufacturing Murder';
